import { ReactNode } from "react";
import { QueryProvider } from "./QueryProvider";
import { RouterProvider } from "./router/RouterProvider";
import { ToasterProvider } from "./ToasterProvider";

interface AppProvidersProps {
  children?: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <ToasterProvider>
        <RouterProvider>{children}</RouterProvider>
      </ToasterProvider>
    </QueryProvider>
  );
}

// 개별 provider들도 export
export { QueryProvider } from "./QueryProvider";
export { RouterProvider } from "./router/RouterProvider";
export { ToasterProvider } from "./ToasterProvider";
